import React, { useContext, useEffect } from "react";
import ApplicationContext from "../../../context/ApplicationContext";
import { Button, Modal } from "react-bootstrap";

import { IEndTableModalProps } from "./IEndTableModalProps";
import { generateGUID } from "../../../helpers/Helper";
import { IReceiptRow } from "../../../types/IReceiptRow";
import { IProduct } from "../../../types/IProduct";
import {
  formatDateTime,
  totalDuration,
  totalHireTable,
} from "../../helpers/Helpers";
import { ICustomRow } from "../../../types/ICustomRow";

export const EndTableModal: React.FC<IEndTableModalProps> = (
  props: IEndTableModalProps
): JSX.Element => {
  const context = useContext(ApplicationContext);

  const [payValue, setPayValue] = React.useState("");
  const [saving, setSaving] = React.useState(false);
  const [error, setError] = React.useState(false);

  useEffect(() => {
    setError(false);
    setPayValue("");
  }, [props.show]);

  function deleteLastChar() {
    const v = payValue;
    const newValue = v.substring(0, v.length - 1);
    setPayValue(newValue);
  }

  const paymentScreen = () => (
    <>
      <div
        style={{
          width: "100%",
          // justifyContent: "center",
          fontSize: 16,
          display: "flex",
        }}
      >
        <div>
          <div>
            This will take you to epos screen where additional item added and
            total calculated
          </div>
        </div>
      </div>
    </>
  );

  const customerModal = (): JSX.Element => {
    return (
      <>
        <Modal show={props.show} onHide={() => props.close()} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>End Table ?</Modal.Title>
          </Modal.Header>
          <Modal.Body>{paymentScreen()}</Modal.Body>
          <Modal.Footer className="modal-footer">
            <div>
              <Button
                variant="secondary"
                style={{
                  width: 100,
                  height: 50,
                  fontSize: 20,
                }}
                onClick={() => props.close()}
              >
                Cancel
              </Button>
            </div>

            <Button
              variant="success"
              style={{
                width: 300,
                height: 50,
                fontSize: 20,
              }}
              onClick={() => addToReceipt()}
            >
              OK
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  function addToReceipt() {
    const advPayRow = addAdvancePaymentRow();
    const hireRow = addHireToReceiptRow();

    if (advPayRow !== undefined) {
      context.Receipt.addRow(advPayRow);
    }
    context.Receipt.addRow(hireRow);

    props.endTable();
  }

  function addAdvancePaymentRow() {
    if (props.table.advancePayment < 1) {
      return;
    }

    const defaultProduct = context.BranchMenu.getMenu().products[0];
    let product: IProduct = JSON.parse(JSON.stringify(defaultProduct));

    product.description = "Advance payment";
    product.price = props.table.advancePayment * -1;
    product.qty = 1;
    product.id = -1;

    const receiptRow: IReceiptRow = {
      id: context.Receipt.getRows().length + 1,
      product: product,
      variations: [],
      extras: [],
      commonOptions: [],
      notes: "",
      instructions: [],
      description: ["Advance Payment"],
      price: product.price,
      qty: 1,
      isDiscount: false,
      options: [],
      uuid: generateGUID(),
    };

    return receiptRow;
  }

  function addHireToReceiptRow() {
    const defaultProduct = context.BranchMenu.getMenu().products[0];
    let product: IProduct = JSON.parse(JSON.stringify(defaultProduct));

    product.description = props.table.description;
    product.price = totalHireTable(props.table);
    product.qty = 1;
    product.id = -1;

    const notes =
      formatDateTime(props.table.startTime) +
      " -> " +
      formatDateTime(new Date()) +
      " | Duration : " +
      totalDuration(props.table);

    const receiptRow: IReceiptRow = {
      id: context.Receipt.getRows().length + 1,
      product: product,
      variations: [],
      extras: [],
      commonOptions: [],
      notes: notes,
      instructions: [],
      description: [props.table.description],
      price: product.price,
      qty: 1,
      isDiscount: false,
      options: [],
      uuid: generateGUID(),
    };

    return receiptRow;
  }

  return (
    <>
      <>{customerModal()}</>
    </>
  );
};
